import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { css } from 'emotion';

const CloseButton = styled.button`
  height: 100%;
  width: 100%;
  padding: 0;
  &:hover g {
    fill: #7f8287;
    stroke: #7f8287;
  }
`;

const CloseButtonWrapper = styled.div`
  margin: 16px;
  width: 18px;
  height: 18px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
`;

const fadeIn = keyframes`
  0%   { opacity: 0;}
  100% { opacity: 1 }
`;

const OverlayContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.96);
  z-index: 21;
  animation: ${fadeIn} 0.5s;
`;

const ContentContainerCss = css`
  padding: 25px 18px;
  @media (min-width: $screen-sm) {
    padding: 32px 50px;
  }
`;

const DialogCss = css`
  .modal-content {
    border-radius: 10px;
  }
`;

const FullScreenModalDialog = css`
  @media (max-width: 600px) {
    margin: 0;
    height: 100vh;
    height: -webkit-fill-available;
    width: 100%;
    background-color: #fff;
    .modal-content {
      height: 100vh;
      height: -webkit-fill-available;
      box-shadow: none;
      margin: 0;
      border: 0;
      border-radius: 0;
    }
  }
`;

export {
  ContentContainerCss,
  CloseButton,
  CloseButtonWrapper,
  OverlayContainer,
  DialogCss,
  FullScreenModalDialog,
};
